import { useState } from 'react';
import AccountLayout from '@/components/feature/AccountLayout';

const banks = [
  { id: 'b1', name: 'Vietcombank', number: '0011 0022 3344', holder: 'NGUYEN VAN AN', isDefault: true },
  { id: 'b2', name: 'Techcombank', number: '1903 5566 7788', holder: 'NGUYEN VAN AN', isDefault: false },
];

const bankList = [
  'Vietcombank',
  'VietinBank',
  'BIDV',
  'Agribank',
  'Techcombank',
  'ACB',
  'Sacombank',
  'VPBank',
  'MB',
  'SHB',
  'VIB',
  'TPBank',
  'Eximbank',
  'HDBank',
  'OCB',
  'SeABank',
  'MSB',
  'Nam A Bank',
  'NCB',
  'OceanBank',
  'PGBank',
  'ABBank',
  'Bac A Bank',
  'Bao Viet Bank',
  'BVBank',
  'CB Bank',
  'Dong A Bank',
  'GPBank',
  'Kienlongbank',
  'LienVietPostBank',
  'PVcomBank',
  'Saigonbank',
  'SCB',
  'Viet A Bank',
  'VietBank',
  'Viet Capital Bank',
  'CIMB Vietnam',
  'Hong Leong Bank',
  'HSBC Vietnam',
  'Public Bank Vietnam',
  'Shinhan Bank',
  'Standard Chartered',
  'UOB Vietnam',
  'Woori Bank',
  'Indovina Bank',
  'VRB (Việt Nga)',
  'Kasikornbank',
];

export default function Bank() {
  const [showForm, setShowForm] = useState(false);

  return (
    <AccountLayout>
      <div className="max-w-2xl mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-2xl font-bold text-foreground-950">Ngân hàng liên kết</h1>
            <p className="text-foreground-600 mt-1">Quản lý tài khoản ngân hàng để nạp và rút tiền.</p>
          </div>
          <button
            onClick={() => setShowForm(!showForm)}
            className="px-4 py-2.5 rounded-md bg-primary-500 text-background-950 text-sm font-semibold hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors"
          >
            <i className="ri-add-line mr-1"></i> Liên kết mới
          </button>
        </div>

        {showForm && (
          <div className="rounded-xl border border-background-200/60 bg-background-100 p-6 mb-6">
            <h3 className="text-base font-semibold text-foreground-950 mb-4">Thêm tài khoản ngân hàng</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Tên ngân hàng</label>
                <select className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500">
                  <option value="" disabled>Chọn ngân hàng</option>
                  {bankList.map((bank) => (
                    <option key={bank} value={bank}>{bank}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Số tài khoản</label>
                <input placeholder="Nhập số tài khoản" className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
              </div>
              <div>
                <label className="block text-xs font-semibold text-foreground-600 mb-1.5">Chủ tài khoản</label>
                <input placeholder="Tên chủ tài khoản (không dấu)" className="w-full px-3 py-2.5 rounded-md bg-background-50 border border-background-300/60 text-sm text-foreground-900 focus:outline-none focus:border-primary-500" />
              </div>
              <button className="w-full py-3 rounded-md bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors">
                Xác nhận liên kết
              </button>
            </div>
          </div>
        )}

        <div className="space-y-4">
          {banks.map((b) => (
            <div key={b.id} className="rounded-xl border border-background-200/60 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-lg bg-primary-500/15 flex items-center justify-center">
                    <i className="ri-bank-line text-primary-400 text-xl"></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2">
                      <p className="text-base font-semibold text-foreground-950">{b.name}</p>
                      {b.isDefault && <span className="px-2 py-0.5 rounded-full bg-primary-500/15 text-primary-400 text-xs font-semibold">Mặc định</span>}
                    </div>
                    <p className="text-sm text-foreground-600">{b.number} · {b.holder}</p>
                  </div>
                </div>
                <button className="text-sm font-semibold text-foreground-600 hover:text-rose-400 cursor-pointer whitespace-nowrap transition-colors">
                  <i className="ri-delete-bin-6-line mr-1"></i> Gỡ
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AccountLayout>
  );
}